import { useState } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { AudioTrack } from '../types/instance';

export const useAudioTracks = () => {
    const instance = usePlayerInstance();
    const [audioTracks, setAudioTracks] = useState<ReadonlyArray<AudioTrack> | undefined>(
        () => instance?.audioTracks
    );

    useInstanceEffect((instance) => instance.onAudioTracksChange(setAudioTracks));

    return audioTracks;
};
